<template>
  <ol-vector-layer>
    <ol-overlay :position="[easting, northing]" :autoPan="false" :offset="[-320, popupHeight]">
      <Popup :cableLength="cableLength" id="popup" />
    </ol-overlay>
  </ol-vector-layer>
</template>

<script setup lang="ts">
import Popup from './Popup.vue'
import { computed, defineProps } from 'vue'
import { usePopupStore } from '@/stores/PopupStore'

defineProps({
  cableLength: Number
})

const popupStore = usePopupStore()

const easting = computed(() => popupStore.easting)
const northing = computed(() => popupStore.northing)

const popupHeight = computed(() => {
  if (popupStore.showCabel) {
    return -175
  } else if (popupStore.showVessel) {
    return -240
  }
  return 0
})
</script>

<style scoped></style>
